import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Error404Component } from './shared/error404/error404.component';
import { EquipoComponent } from './www-info/equipo/pages/equipo/equipo.component';
import { HomeComponent } from './www-info/home/pages/home/home.component';
import { QuienesSomosComponent } from './www-info/quienes-somos/pages/quienes-somos/quienes-somos.component';
import { EquipoPersonaComponent } from './www-info/equipo/pages/equipo-persona/equipo-persona.component';
import { SalaDePrensaComponent } from './www-info/sala-de-prensa/pages/sala-de-prensa/sala-de-prensa.component';
import { ArticuloComponent } from './www-info/sala-de-prensa/pages/articulo/articulo.component';
import { RetalkComponent } from './www-info/retalk/pages/retalk/retalk.component';
import { PodcastComponent } from './www-info/retalk/pages/podcast/podcast.component';
import { CasosExitoComponent } from './www-info/casos-exito/pages/casos-exito/casos-exito.component';
import { CasoComponent } from './www-info/casos-exito/pages/caso/caso.component';
import { EsgComponent } from './www-info/esg/pages/esg/esg.component';
import { ContactoComponent } from './www-info/contacto/pages/contacto/contacto.component';
import { AvisoLegalComponent } from './www-info/legal/pages/aviso-legal/aviso-legal.component';
import { ProteccionDatosComponent } from './www-info/legal/pages/proteccion-datos/proteccion-datos.component';
import { AccesibilidadComponent } from './www-info/legal/pages/accesibilidad/accesibilidad.component';
import { CookiesComponent } from './www-info/legal/pages/cookies/cookies.component';
import { PropertiespreComponent } from './www-properties/pages/propertiespre/propertiespre.component';
import { PropertiesmainComponent } from './www-properties/pages/propertiesmain/propertiesmain.component';
import { GeocodingComponent } from './www-properties/pages/geocoding/geocoding.component';
import { PropertydetailComponent } from './www-properties/pages/propertydetail/propertydetail.component';
import { ArticuloPreviewComponent } from './www-info/sala-de-prensa/pages/articulo-preview/articulo-preview.component';
import { JobsComponent } from './www-info/equipo/pages/jobs/jobs.component';
import { PillsComponent } from './www-info/retalk/pages/pills/pills.component';
import { PillComponent } from './www-info/retalk/pages/pill/pill.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'quienes-somos',
    component: QuienesSomosComponent,
    data: { title: 'retailCo. Quiénes somos.' }
  },
  {
    path: 'inmuebles',
    component: PropertiespreComponent,
    data: { title: 'retailCo. Inmuebles.' }
  },
  {
    path: 'inmueblesmain',
    component: PropertiesmainComponent,
    data: { title: 'retailCo. Inmuebles.' }
  },
  {
    path: 'geocoding',
    component: GeocodingComponent,
    data: { title: 'retailCo. Inmuebles.' }
  },
  {
    path: 'property/:id',
    component: PropertydetailComponent,
    data: { title: 'retailCo. Detalle de inmueble :id.' }
  },
  {
    path: 'equipo',
    children: [
      {
        path: '',
        component: EquipoComponent,
        data: { title: 'retailCo. Equipo' }
      },
      {
        path: 'jobs',
        component: JobsComponent,
        data: { title: 'retailCo. Ofertas de empleo' }
      },
      {
        path: ':id',
        component: EquipoPersonaComponent,
        data: { title: 'retailCo. Equipo' }
      },
    ],
  },
  {
    path: 'sala-de-prensa',
    children: [
      {
        path: '',
        component: SalaDePrensaComponent,
        data: { title: 'retailCo. Sala de prensa' }
      },
      {
        path: ':id',
        component: ArticuloComponent,
        data: { title: 'retailCo. Sala de prensa' }
      },
      {
        path: 'preview/:id',
        component: ArticuloPreviewComponent,
        data: { title: 'retailCo. Sala de prensa' }
      }
    ],
  },
  {
    path: 'retalk',
    children: [
      {
        path: '',
        component: RetalkComponent,
        data: { title: 'retailCo. Retalk' }
      },
      {
        path: ':id',
        component: PodcastComponent,
        data: { title: 'retailCo. Retalk :id' }
      }
    ],
  },
  {
    path: 'pills',
    children: [
      {
        path: '',
        component: PillsComponent,
        data: { title: 'retailCo. Retalk: Pills' }
      },
      {
        path: ':id',
        component: PillComponent,
        data: { title: 'retailCo. Retalk: Pill :id' }
      }
    ],
  },
  {
    path: 'casos-exito',
    children: [
      {
        path: '',
        component: CasosExitoComponent,
        data: { title: 'retailCo. Casos de éxito' }
      },
      {
        path: ':id',
        component: CasoComponent,
        data: { title: 'retailCo. Casos de éxito' }
      }
    ],
  },
  {
    path: 'esg',
    component: EsgComponent,
    data: { title: 'retailCo. ESG' }
  },
  {
    path: 'contacto',
    component: ContactoComponent,
    data: { title: 'retailCo. Contacto' }
  },
  {
    path: 'aviso-legal',
    component: AvisoLegalComponent,
    data: { title: 'retailCo. Aviso legal' }
  },
  {
    path: 'proteccion-datos',
    component: ProteccionDatosComponent,
    data: { title: 'retailCo. Protección de datos' }
  },
  {
    path: 'cookies',
    component: CookiesComponent,
    data: { title: 'retailCo. Política de cookies' }
  },
  {
    path: 'accesibilidad',
    component: AccesibilidadComponent,
    data: { title: 'retailCo. Accesibilidad' }
  },
  {
    path: '404',
    component: Error404Component

  },
  {
    path: '**',
    // redirectTo: ''
    component: Error404Component
  }

]

@NgModule({

  imports: [
    RouterModule.forRoot(routes,
      {
        onSameUrlNavigation: 'reload',
        scrollPositionRestoration: 'enabled',
        useHash: false,
        anchorScrolling: 'enabled'
      })
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule { }
